export default __webpack_public_path__ + "static/media/1246.02c37e09.jpeg";